import { BaseListenable1u3g4s45l82o6 as BaseListenable } from '../../../../../../reactive/com/lightningkite/reactive/core/abstracts.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  getValue6qi464mhg2s5 as getValue,
  setValue39oxnnnmdq4h2 as setValue,
  lens2e2i845xidu26 as lens,
  lens26es9640ifscs as lens_0,
  get_state389x218zizu8a as get_state,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
} from '../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function vprop(_this__u8e3s4, eventName, get, set) {
  return vprop$1().scq(_this__u8e3s4, eventName, get, set);
}
function vevent(_this__u8e3s4, eventName) {
  return vevent$1().ucq(_this__u8e3s4, eventName);
}
var vprop$1Class;
function vprop$1() {
  if (vprop$1Class === VOID) {
    class $ extends BaseListenable() {
      static scq($this_vprop, $eventName, $get, $set, $box) {
        if ($box === VOID)
          $box = {};
        $box.pcq_1 = $this_vprop;
        $box.qcq_1 = $get;
        $box.rcq_1 = $set;
        var $this = this.sam($box);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var tmp0_safe_receiver = $this_vprop.vb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener($eventName, (it) => {
            $this.kal();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = $this_vprop.eb4_1['on' + $eventName];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + $eventName;
          $this_vprop.eb4_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            $this.kal();
            return Unit_instance;
          };
        }
        return $this;
      }
      vcq(value) {
        this.rcq_1(this.pcq_1, value);
        this.kal();
      }
      mam(_set____db54di) {
        return this.vcq((_set____db54di == null ? true : !(_set____db54di == null)) ? _set____db54di : THROW_CCE());
      }
      f2() {
        return this.qcq_1(this.pcq_1);
      }
      wcq(value, $completion) {
        this.rcq_1(this.pcq_1, value);
        this.kal();
      }
      gah(value, $completion) {
        return this.wcq((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
      }
      oam(thisRef, property) {
        return this.nam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      qam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.pam(tmp, property, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    protoOf($).cak = valueSet;
    protoOf($).nam = getValue;
    protoOf($).pam = setValue;
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    protoOf($).qah = get_state;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactiveValue(), BaseListenable()], [1]);
    vprop$1Class = $;
  }
  return vprop$1Class;
}
var vevent$1Class;
function vevent$1() {
  if (vevent$1Class === VOID) {
    class $ extends BaseListenable() {
      static ucq($this_vevent, $eventName) {
        var $this = this.sam();
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var tmp0_safe_receiver = $this_vevent.vb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener($eventName, (it) => {
            $this.kal();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = $this_vevent.eb4_1['on' + $eventName];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + $eventName;
          $this_vevent.eb4_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            $this.kal();
            return Unit_instance;
          };
        }
        return $this;
      }
    }
    initMetadataForClass($);
    vevent$1Class = $;
  }
  return vevent$1Class;
}
//region block: exports
export {
  vevent as vevent2d70lzbz6q2i1,
  vprop as vpropka48um9uweps,
};
//endregion

//# sourceMappingURL=helpers.commonHtml.mjs.map
